import { render, staticRenderFns } from "./MobileDataPlans.vue?vue&type=template&id=c5f28260&"
import script from "./MobileDataPlans.vue?vue&type=script&lang=js&"
export * from "./MobileDataPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports